import { WlthNewIcon } from '@components/icons/light/WlthNewIcon.tsx'

export const cryptoIconsMap = {
  WLTH: <WlthNewIcon width={40} height={40} />,
  ETH: <img src="/images/assets/eth.png" alt="eth-icon" className="h-10" />,
  USDC: <img src="/images/assets/usdc.svg" alt="usdc-icon" className="h-10" />,
  USDT: <img src="/images/assets/usdt.png" alt="usdt-icon" className="h-10" />,
  WETH: <img src="/images/assets/weth.png" alt="weth-icon" className="h-10" />,
}

export const cryptoDetailsMap = {
  WLTH: {
    symbol: '$WLTH',
    name: 'WLTH Token',
  },
  ETH: {
    symbol: 'ETH',
    name: 'Ethereum',
  },
  USDC: {
    symbol: 'USDC',
    name: 'USD Coin',
  },
  USDT: {
    symbol: 'USDT',
    name: 'Tether',
  },
}
